<!--
    App.vue
    The SPA starts here.
    by Guy E. White <guw968@g.harvard.edu>
-->
<template>
  <div id="app">
    <img alt="Dr Guy's Logo" id='logo' src="./assets/images/logo.png">
    <h1>Statistic Chooser</h1>
    <p class='header-text'>Dr Guy's Statistic Chooser is a free tool to help doctoral dissertation and thesis writers select a statistical test.</p>
    <p class='instructions'>To begin, select an option below.</p>

    <nav>
        <ul>
            <li v-for='link in links' :key='link'>
                <router-link exact :to='{ name: link }'>{{ link }}

                <!-- Modifications to add My Tests count -->
                <span data-test='mytests-count' v-if='link == "my tests"'><sup>({{ mytestsCount }})</sup></span>

                </router-link>
            </li>
        </ul>
    </nav>

    <router-view></router-view>
  </div>

</template>

<script>
import * as app from '@/common/app.js';

export default {
  name: 'App',
  data: function() {
        return {
            links: ['home', 'choose a statistical test', 'see all tests', 'suggest a test', 'my tests'],
      };
  },
  mounted: function() {

        // Initialize an instance of mytests
        let mytests = new app.MyTests();

        // State Management
        this.$store.commit('setMyTestsCount', mytests.count());
        this.$store.dispatch('setProducts');

  },
  computed: {
      mytestsCount: function() {
          return this.$store.state.mytestsCount;
      }
  }
}
</script>

<style lang='scss'>
@import './assets/scss/statchooser.scss'
</style>
